import { render, staticRenderFns } from "./UploadPayslip.vue?vue&type=template&id=51ed6d3a"
import script from "./UploadPayslip.vue?vue&type=script&lang=js"
export * from "./UploadPayslip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports